import { render, staticRenderFns } from "./ValidStore.vue?vue&type=template&id=16841e4c"
import script from "./ValidStore.vue?vue&type=script&lang=js"
export * from "./ValidStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports